import React from 'react'

export default function TextIcon({ text }) {
  return (
    <svg viewBox="0 0 20 20" width='20' height='20'>
      <text x="10" y="15" width='20' height='20' textAnchor='middle' fontSize='13px' fill={'gainsboro'}>
        {text}
      </text>
    </svg>
  )
}

TextIcon.displayName = 'EyeIcon'
